<template>
    <div class="gallery-groups">
        <el-dialog title="图库管理" :visible.sync="dialogShow" width="980px" top="50px" @close="dialogClose">
            <div class="gallery-group" v-loading="loading">
                <div class="header-group"> 
                    <div class="header-tab">
                        <el-tabs v-model="activeName" @tab-click="handleClick">
                            <el-tab-pane label="直播课背景" name="1" :disabled="disabled"></el-tab-pane>
                            <el-tab-pane label="直播课封面" name="2" :disabled="disabled"></el-tab-pane>
                            <el-tab-pane label="点播课封面" name="3" :disabled="disabled"></el-tab-pane>
                            <el-tab-pane label="课程详情页封面" name="5" :disabled="disabled"></el-tab-pane>
                            <el-tab-pane label="课程详情页视频" name="4" :disabled="disabled"></el-tab-pane>
                        </el-tabs>
                    </div>
                    <!-- <div>
                        <el-select v-model="coachId" placeholder="请选择" @change="initMetod">
                            <el-option
                                v-for="item in coachesData"  
                                :key="item.id"
                                :label="item.coachName"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </div> -->
                    <div class="header-upload">
                        <el-upload
                            :action="imgLoadPath"
                            :show-file-list="false"
                            :on-error="handleError"
                            :on-success="handleBeforeUpload1"
                            :before-upload="beforeUpload"
                            :headers="{'yj-admin-token':token}"
                        >
                            <el-button size="medium" type="primary">上传<i class="el-icon-upload el-icon--right"></i></el-button>
                        </el-upload>
                        <span style="font-size:12px;white-space: nowrap;" v-if="activeName == 4">视频格式:mp4</span>
                        <span style="font-size:12px;white-space: nowrap;" v-else>图片格式:jpg、jpeg、png</span>
                    </div>
                </div>
                <div class="gallery-content Scrollbars-box"> 
                    <div v-show="activeName == 1" class="gallery-container">
                        <div class="gallery-img-box" v-for="(item,index) in imgList1" :key="index">
                            <div class="gallery-img-item">
                                <div class="gallery-img-cover" @click="choiceImgMethod(item)">
                                    <img style="width: 100%; height: 110px;object-fit: cover;" :src="item.coverUrl" alt="">
                                    <div class="gallery-img-hover">选用此图</div>
                                </div>
                                <div class="gallery-img-fun">
                                    <el-button type="text" icon="el-icon-zoom-in" @click="showBigImg(index)">查看大图</el-button> 
                                    <el-button type="text" style="color:red;" icon="el-icon-delete" @click="deleta(item,index)">删除</el-button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-show="activeName == 2" class="gallery-container">
                        <div class="gallery-img-box" v-for="(item,index) in imgList2" :key="index">
                            <div class="gallery-img-item">
                                <div class="gallery-img-cover" @click="choiceImgMethod(item)">
                                    <img style="width: 100%; height: 110px;object-fit: cover;" :src="item.coverUrl" alt="">
                                    <div class="gallery-img-hover">选用此图</div>
                                </div>
                                <div class="gallery-img-fun">
                                    <el-button type="text" icon="el-icon-zoom-in" @click="showBigImg(index)">查看大图</el-button>
                                    <el-button type="text" style="color:red;" icon="el-icon-delete" @click="deleta(item,index)">删除</el-button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-show="activeName == 3" class="gallery-container">
                        <div class="gallery-img-box" v-for="(item,index) in imgList3" :key="index">
                            <div class="gallery-img-item">
                                <div class="gallery-img-cover" @click="choiceImgMethod(item)">
                                    <img style="width: 100%; height: 110px;object-fit: cover;" :src="item.coverUrl" alt="">
                                    <div class="gallery-img-hover">选用此图</div>
                                </div>
                                <div class="gallery-img-fun">
                                    <el-button type="text" icon="el-icon-zoom-in" @click="showBigImg(index)">查看大图</el-button>
                                    <el-button type="text" style="color:red;" icon="el-icon-delete" @click="deleta(item,index)">删除</el-button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-show="activeName == 4" class="gallery-container">
                        <div class="gallery-img-box" v-for="(item,index) in imgList4" :key="index">
                            <div class="gallery-img-item">
                                <div class="gallery-img-cover" @click="choiceImgMethod(item)">
                                    <video style="width: 100%; height: 110px;object-fit: cover;" :src="item.coverUrl" controls></video>
                                    <div class="gallery-img-hover">选用此视频</div>
                                </div>
                                <div class="gallery-img-fun">
                                    <el-button type="text" style="color:red;" icon="el-icon-delete" @click="deleta(item,index)">删除</el-button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-show="activeName == 5" class="gallery-container">
                        <div class="gallery-img-box" v-for="(item,index) in imgList5" :key="index">
                            <div class="gallery-img-item">
                                <div class="gallery-img-cover" @click="choiceImgMethod(item)">
                                    <img style="width: 100%; height: 110px;object-fit: cover;" :src="item.coverUrl" alt="">
                                    <div class="gallery-img-hover">选用此图</div>
                                </div>
                                <div class="gallery-img-fun">
                                    <el-button type="text" icon="el-icon-zoom-in" @click="showBigImg(index)">查看大图</el-button>
                                    <el-button type="text" style="color:red;" icon="el-icon-delete" @click="deleta(item,index)">删除</el-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>    
            </div>
        </el-dialog>
        <el-image-viewer
            v-if="dialogVisible"
            :zIndex="9999"
            :on-close="()=>dialogVisible=false"
            :url-list="imgList"
            :initial-index="imgIndex"
        />
    </div>
</template>

<script>
import ElImageViewer from "element-ui/packages/image/src/image-viewer";
export default {
    name: 'IDReady',
    props: {
        dialog:{
            type:Boolean,
            default:false
        },
        choiceImg:{
            type:Function,
            default:function(){}
        },
        active:{
            type:String,
            default:'1'
        },
         disabled:{
            type:Boolean,
            default:false
        }
    },
    components:{ElImageViewer},
    data() { 
        return {
            url:'',
            activeName: '1',
            loading:false,
            dialogShow:false,
            dialogVisible:false,
            docLoadPath: '',
            uploadLogin: null,
            imgList:[],
            imgList1:[],
            imgList2:[],
            imgList3:[],
            imgList4:[],
            imgList5:[],
            imgIndex:0,
            coachId:'',
            coachesData:[],
            token:window.localStorage.getItem('token')
        };
    },
    computed:{
        imgLoadPath:function(){
            let url='';
            if(this.activeName == 1){
                url='/courseCover/live/background';
            }else if(this.activeName == 2){
                url='/courseCover/live/cover';
            }else if(this.activeName == 3){
                url='/courseCover/video/cover';
            }else if(this.activeName == 4){
                url='/courseCover/intro/video';
            }else if(this.activeName == 5){
                url='/courseCover/intro/cover';
            }
            return process.env.API_ROOT+url;
        }
    },
    watch: {
        dialog: function (val, oldVal) {
            this.dialogShow = val;
        },
        active(val,old){
            console.log('val',val);
            console.log('old',old);
            if(val!=old){
                this.activeName=val;
                this.handleClick()
            }
        },
    },
    created() {
        this.activeName=this.active;
        const sysRoleId=window.localStorage.getItem('sysRoleId');
        const userId=window.localStorage.getItem('userId');
        if(sysRoleId && this.$_.isString(sysRoleId) && sysRoleId==6){
            this.coachId=this.$_.isNumber(Number(userId))?Number(userId):'';
        }
       this.handleClick()
    },
    methods: {
         //选择教练
        selCoachesData() {
            this.$get('/coaches', {pageNum:1,limit:1000})
                .then(res => {
                    if (res.code == 0) {
                        let list = Array.isArray(res.data.list)?res.data.list:[];
                        if(!this.coachId){
                            this.coachId=list.length>0?list[0].id:0;
                        }
                        this.coachesData=list;
                    } else {
                        this.$message.error(res.message);
                    }
                })
                .catch(() => {
                    console.log();
                });
        },
        choiceImgMethod(data){
            this.choiceImg(data);
            this.$emit('update:dialog', false);
        },
        showBigImg(index){
            if(this.activeName == 1){
                this.imgList=this.imgList1.map(item=>item.coverUrl);
            }else if(this.activeName == 2){
                this.imgList=this.imgList2.map(item=>item.coverUrl);
            }else if(this.activeName == 3){
                this.imgList=this.imgList3.map(item=>item.coverUrl);
            }else if(this.activeName == 5){
                this.imgList=this.imgList5.map(item=>item.coverUrl);
            }
            this.imgIndex=index;
            this.dialogVisible=true;
        }, 
        deleta(data,index){
            this.loading=true;
            this.$delete(`/courseCover/delete/${data.id}`).then((res) => {
                if (res.code == 0) {
                    console.log(res);
                    if(this.activeName == 1){
                        this.imgList1.splice(index,1)
                    }else if(this.activeName == 2){
                        this.imgList2.splice(index,1)
                    }else if(this.activeName == 3){
                         this.imgList3.splice(index,1)
                    }else if(this.activeName == 4){
                         this.imgList4.splice(index,1)
                    }else if(this.activeName == 5){
                         this.imgList5.splice(index,1)
                    }
                } else {
                    this.$message.error(JSON.stringify(res.message));
                }
                 this.loading=false;
            }).catch(err=>{
                this.$message.error(JSON.stringify(err));
                this.loading=false;
            })
        },
        handleClick(){
            if(this.activeName == 1){
                if(this.imgList1.length == 0)this.initMetod()
            }else if(this.activeName == 2){
                if(this.imgList2.length == 0)this.initMetod()
            }else if(this.activeName == 3){
                if(this.imgList3.length == 0)this.initMetod()
            }else if(this.activeName == 4){
                if(this.imgList4.length == 0)this.initMetod()
            }else if(this.activeName == 5){
                if(this.imgList5.length == 0)this.initMetod()
            }
        },
        initMetod(){
           this.loading=true;
        //    ,coachId:this.coachId
            this.$get('/courseCover/list', {coverType:this.activeName}).then((res) => {
                if (res.code == 0) {
                    let list=Array.isArray(res.data)?res.data:[]
                    if(this.activeName == 1){
                        this.imgList1=list
                    }else if(this.activeName == 2){
                        this.imgList2=list
                    }else if(this.activeName == 3){
                         this.imgList3=list
                    }else if(this.activeName == 4){
                         this.imgList4=list
                    }else if(this.activeName == 5){
                         this.imgList5=list
                    }
                } else {
                    this.$message.error(JSON.stringify(res.message));
                }
                 this.loading=false;
            }).catch(err=>{
                this.$message.error(JSON.stringify(err));
                this.loading=false;
            })
        },
        dialogClose(){
            this.$emit('update:dialog', false);
        },
        handleBeforeUpload1(response) {
           this.loading=false;
            if (response.code == 0) {
                this.$message.success('上传成功');
                this.initMetod()
            } else {
                this.$message.error(response.message);
            }
        },
        beforeUpload: function (file) {
            var FileExt = file.name.replace(/.+\./, '');
            const extArr=this.activeName == 4?['mp4']:['jpg', 'jpeg', 'png'];
            if (extArr.indexOf(FileExt.toLowerCase()) === -1) {
                this.$message({
                    type: 'warning',
                    message: '文件格式错误！'
                });
                return false;
            }
            this.loading=true;
        },
        handleError(){
            this.loading=false;
            this.$message.error('上传失败');
        },
    }
};
</script>

<style scoped>
.gallery-group {
    width: 950px;
    height: 600px;
    padding-top:50px;
    position: relative;
}
.header-group{
    position: absolute;
    top:0;
    left:0;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 0;
    border-bottom:1px solid #eee;
    height: 40px;
    
} 
.gallery-content{
    height: 100%;
}
.gallery-container{
    display: flex;
    align-content: flex-start;
    flex-wrap: wrap;
} 
.gallery-img-box{
    width: 25%;
    padding:10px;
} 
.gallery-img-item{
    background: #ffffff;
    box-shadow: 0 12px 20px 0 rgba(0,0,0,.2);
    border-radius: 6px;
    overflow: hidden;
    font-size: 0;
} 
.gallery-img-fun{
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.gallery-img-cover{
    position: relative;
    cursor: pointer;
}
.gallery-img-cover:hover .gallery-img-hover{
    display: flex;
}
.gallery-img-hover{
  position: absolute;
  top:0;
  left:0;
  bottom:0;
  right: 0;
  display: none;
  align-items: center;
  justify-content: center;
  background: rgba(0,0,0,.6);
  font-size: 16px;
  color:#fff;
  z-index: 99;
}
.header-upload{
    display: flex;
    align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/GalleryModel.vue